import { createAction } from 'redux-actions';
export const CLEAR_PREVIOUSLY_FOCUSED_THREAD_ID = 'CLEAR_PREVIOUSLY_FOCUSED_THREAD_ID';
export const clearPreviouslyFocusedThreadId = createAction(CLEAR_PREVIOUSLY_FOCUSED_THREAD_ID);